<template>
  <b-card header="Actualizar proveedor">
    <Form :provider_id="provider_id" />
  </b-card>
</template>

<script>
import Form from './Form'
export default {
  components: { Form },
  data(){
    return {
      provider_id: this.$route.params.id
    }
  }
}
</script>
